<template>
  <div id="content-form" class="content-form" v-if="content != null">
    <div class="form">
      <!--Base content!-->
      <div class="path">
        <label>Caminho</label>
        <label v-if="parent_types.length != 0">
          <span
            v-for="(item, k) in parent_types"
            :key="k"
            @click="
              $router.push({
                name: 'pages_cms',
                params: { id: $route.params.id },
                query: { filter: item.id },
              })
            "
            class="parent"
            >{{ item.languages[0].name }}/</span
          >
          <span
            @click="
              $router.push({
                name: 'pages_cms',
                params: { id: $route.params.id },
                query: { filter: content.type.id },
              })
            "
            class="parent"
            >{{ content.type.languages[0].name }}/</span
          >
          <span>{{ content.languages[language_index].name }}</span>
        </label>
        <label v-else>
          <span
            @click="
              $router.push({
                name: 'pages_cms',
                params: { id: $route.params.id },
                query: { filter: content.type.id },
              })
            "
            class="parent"
            >{{ content.type.languages[0].name }}/</span
          >
          <span>{{
            content.languages[language_index]
              ? content.languages[language_index].name
              : ""
          }}</span>
        </label>
      </div>
      <fyi-text
        v-bind:value="content.languages[language_index].name"
        @input-text="
          content.languages[language_index].name = $event;
          $parent.$parent.content_name = $event;
          $refs.seo.analyze();
        "
        :label="'Título'"
        ref="name"
        :required="true"
        :inputError="true"
        :charCount="true"
        :icon_box="false"
        :full="true"
        :key="languageChange"
      />
      <fyi-text
        v-bind:value="content.languages[language_index].sub_name"
        @input-text="content.languages[language_index].sub_name = $event"
        :label="'Subtítulo'"
        :charCount="true"
        :icon_box="false"
        :full="true"
        :key="languageChange"
      />
      <fyi-text
        id="url"
        v-bind:value="content.languages[language_index].alias"
        @input-text="content.languages[language_index].alias = $event"
        :label="'URL'"
        :icon_box="false"
        :full="true"
        :key="languageChange"
      />
      <span><i class="i-info"></i> se deixar vazio assume o título</span>
      <fyi-textarea
        ref="body"
        v-bind:value="content.languages[language_index].body"
        @input="
          content.languages[language_index].body = $event;
          updateSEO($event);
        "
        :label="'Texto'"
        :toolbar="'full'"
        :textAreaID="'body'"
        :key="languageChange"
      />
      <fyi-textarea
        ref="description"
        v-bind:value="content.languages[language_index].description"
        @input="content.languages[language_index].description = $event"
        :label="'Descrição'"
        :toolbar="'mini'"
        :textAreaID="'description'"
        :key="languageChange"
      />
      <Date
        v-if="$route.name.includes('edit')"
        :value="content.created_at.split(' ')[0]"
        @update:modelValue="
          content.created_at =
            new Date($event).toLocaleDateString('en-CA', {
              format: 'short',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            }) +
            ' ' +
            content.created_at.split(' ')[1]
        "
        :label="'Data de Criação'"
      />
      <Time
        v-if="$route.name.includes('edit')"
        :value="content.created_at.split(' ')[1]"
        @update:modelValue="
          content.created_at =
            content.created_at.split(' ')[0] +
            ' ' +
            $event.hours +
            ':' +
            ($event.minutes < 10 ? '0' + $event.minutes : $event.minutes) +
            ':00'
        "
      />
      <!--Addons!-->
      <ContentAddons
        ref="addons"
        :addons="content.type.addons ? content.type.addons : type.addons"
        :content="content"
        :language="current_language.id"
        :language_index="language_index ? language_index : 0"
        @add-files-attachments="addFilesAttachments"
        @remove-files-attachments="removeFilesAttachments"
        @add-files-vision="addFilesVision"
        @remove-files-vision="removeFilesVision"
      />
      <AddonSEO
        v-if="SEO"
        :language_index="language_index ? language_index : 0"
        ref="seo"
        :key="languageChange"
      />
    </div>
    <div class="options-sidebar">
      <SimpleSelect
        v-if="languageSelector"
        :className="'language'"
        :previewIcon="'i-collapse grey'"
        @select-data-value="setLanguage($event)"
        :options="
          $store.getters.languages.map((t) => {
            return {
              label: t.name,
              value: t.id,
              img:
                'https://purecatamphetamine.github.io/country-flag-icons/3x2/' +
                t.locale.split('-')[1].toUpperCase() +
                '.svg',
              checked: t.id == current_language.id,
            };
          })
        "
      />
      <label class="title">{{
        content.published == 1 ? "Publicado" : "Despublicado"
      }}</label>
      <i
        v-if="$route.name.includes('edit')"
        class="i-swap"
        @click="togglePublish"
      />
      <label
        ><span>Autor: </span>
        <span v-if="content.user != null">{{ content.user.name }}</span></label
      >
      <label
        ><span>Update:</span>
        <span>
          {{
            new Date(content.updated_at).toLocaleDateString("pt-PT", {
              format: "short",
              year: "2-digit",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })
          }}</span
        >
        <i @click="toggleContentHistory" class="i-info"></i>
      </label>
      <div v-if="content_history" class="content-history">
        <label>Histórico de versão</label>
        <i @click="toggleContentHistory" class="i-close"></i>
        <ul>
          <li v-for="(item, k) in revisions" :key="k">
            <label>{{ item.user != null ? item.user.name : "Sistema" }}</label>
            <label>{{
              new Date(item.created_at).toLocaleDateString("pt-PT", {
                format: "short",
                year: "2-digit",
                month: "2-digit",
                day: "2-digit",
              })
            }}</label>
            <label>{{
              new Date(item.created_at)
                .toLocaleDateString("pt-PT", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
                .split(" ")[1]
            }}</label>
            <i
              @click="
                revision = item;
                toggleContentHistory();
              "
              class="far fa-eye"
            ></i>
          </li>
        </ul>
      </div>
      <div class="buttons">
        <span v-if="$route.name.includes('edit')" :onclick="removeContent"
          >Eliminar</span
        >
        <i
          v-else-if="$store.getters.languages.length > 1"
          :title="`Duplicar conteúdo para todos os idiomas: ${
            content.replicate ? 'Ativo' : 'Inativo'
          }`"
          @click="replicate"
          class="i-duplicate"
          :class="{ active: content.replicate }"
        ></i>
        <fyi-button
          :label="$route.name.includes('edit') ? 'Atualizar' : 'Criar'"
          :loading="submitStatus == 'PENDING'"
          :className="
            'default ' + ($route.name.includes('edit') ? 'update' : 'create')
          "
          :onclick="saveContent"
        />
      </div>
      <div class="section scheduler" ref="scheduler">
        <div class="bar" @click="openBar('scheduler')">
          <i class="i-collapse" />
          <label>Agendar publicação</label>
        </div>
        <div class="options">
          <Date
            :value="
              content['schedule_' + schedulerState + 'ed_at'] != null
                ? content['schedule_' + schedulerState + 'ed_at'].split(' ')[0]
                : ''
            "
            @update:modelValue="schedulerDate = $event"
            :label="'Data publicação'"
          />
          <Time
            :value="
              content['schedule_' + schedulerState + 'ed_at'] != null
                ? content['schedule_' + schedulerState + 'ed_at']
                    .split(' ')[1]
                    .slice(0, -3)
                : ''
            "
            @update:modelValue="schedulerTime = $event"
            :label="'Hora'"
          />
          <Switch
            :enabled="content.schedule_unpublished_at != null"
            :showLabel="true"
            :label="'Despublicação'"
            @click="schedulerState = $event ? 'unpublish' : 'publish'"
          />
        </div>
      </div>
      <div class="section pictures" ref="pictures">
        <div class="bar" @click="openBar('pictures')">
          <i class="i-collapse" />
          <label>Imagens</label>
        </div>
        <div class="options">
          <div class="main">
            <label>Imagem principal</label>
            <img
              ref="main_image"
              v-if="content.languages[language_index].image"
              :src="
                $store.getters.appConfig.url +
                content.languages[language_index].image
              "
            />
            <div class="no-image" v-else />
            <div v-if="content.languages[language_index].image" class="overlay">
              <i class="i-remove" @click="removeImage('main')" />
            </div>
            <fyi-button
              :label="'Nova Imagem'"
              :icon="'i-upload'"
              :className="'default new-image'"
              :onclick="() => addImage('main')"
            />
          </div>
          <div class="secondary">
            <label>Imagem alternativa</label>
            <img
              ref="alternative_image"
              v-if="content.languages[language_index].alternative_image"
              :src="
                $store.getters.appConfig.url +
                content.languages[language_index].alternative_image
              "
            />
            <div class="no-image" v-else />
            <div
              v-if="content.languages[language_index].alternative_image"
              class="overlay"
            >
              <i class="i-remove" @click="removeImage('alternative')" />
            </div>
            <fyi-button
              :label="'Nova Imagem'"
              :icon="'i-upload'"
              :className="'default new-image'"
              :onclick="() => addImage('alternative')"
            />
          </div>
        </div>
      </div>
      <div v-if="featureTemplate" class="section templating" ref="templating">
        <div class="bar" @click="addBlock = true">
          <i class="i-collapse" />
          <label>Elementos Extra</label>
        </div>
        <!-- <div class="options">
          <div class="layout">
            <label>Layout</label>
            <SimpleSelect
              :className="'order'"
              :allowSearch="true"
              :previewIcon="'i-order'"
              @select-data-value="setTemplate($event)"
              :options="
                templates.map((t) => {
                  return {
                    label: t.name,
                    value: t.id,
                    checked:
                      content.template != null &&
                      content.template.template_id == t.id,
                  };
                })
              "
            />
            <i class="i-remove" @click="removeTemplate" />
            <div class="preview"></div>
          </div>
        </div> -->
      </div>
    </div>
    <div
      onclick="this.previousElementSibling.classList.toggle('open')"
      class="sidebar-mobile-tab"
    >
      <i class="i-collapse"></i>
    </div>
    <teleport to="body">
      <div v-if="mediaOn" class="modal-media">
        <Media
          :modal="true"
          :mime="'image'"
          :multiSelect="false"
          :destination="destination"
          @add-files-alternative="
            content.languages[language_index].alternative_image = $event[0].path
          "
          @add-files-main="
            content.languages[language_index].image = $event[0].path
          "
        />
      </div>
    </teleport>
    <teleport to="body">
      <Modal ref="modal" />
    </teleport>
    <teleport to="body">
      <Toast v-if="toast_show" :type="toast_type" :message="toast_message" />
    </teleport>
    <teleport to="body">
      <div v-if="revision != null" class="bg">
        <div class="revision" :class="[{ success: revisionChanged }]">
          <label v-if="!revisionChanged" class="revision-title"
            >Selecionar versão</label
          >
          <div v-if="!revisionChanged" class="form">
            <!--Base content!-->
            <div class="autor">
              <label>Autor</label><label>{{ revision.user.name }}</label>
            </div>
            <div class="date">
              <label>Data</label
              ><label>{{
                new Date(revision.created_at).toLocaleDateString("pt-PT", {
                  format: "short",
                  year: "2-digit",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              }}</label>
            </div>
            <fyi-text
              v-bind:value="
                revision.data.languages &&
                revision.data.languages[language_index]
                  ? revision.data.languages[language_index].name
                  : ''
              "
              :label="'Título'"
              ref="name"
              :required="true"
              :inputError="true"
              :charCount="true"
              :icon_box="false"
              :full="true"
              :disabled="true"
            />
            <fyi-text
              v-bind:value="
                revision.data.languages &&
                revision.data.languages[language_index]
                  ? revision.data.languages[language_index].sub_name
                  : ''
              "
              :label="'Subtítulo'"
              :charCount="true"
              :icon_box="false"
              :full="true"
              :disabled="true"
            />
            <fyi-text
              id="url"
              v-bind:value="
                revision.data.languages &&
                revision.data.languages[language_index]
                  ? revision.data.languages[language_index].alias
                  : ''
              "
              :label="'URL'"
              :icon_box="false"
              :full="true"
              :disabled="true"
            />
            <span><i class="i-info"></i> se deixar vazio assume o título</span>
            <fyi-textarea
              v-bind:value="
                revision.data.languages &&
                revision.data.languages[language_index]
                  ? revision.data.languages[language_index].body
                  : ''
              "
              :label="'Texto'"
              :toolbar="'full'"
              :textAreaID="'body'"
              :disabled="true"
            />
            <fyi-textarea
              v-bind:value="
                revision.data.languages &&
                revision.data.languages[language_index]
                  ? revision.data.languages[language_index].description
                  : ''
              "
              :label="'Descrição'"
              :toolbar="'mini'"
              :textAreaID="'description'"
              :disabled="true"
            />
            <!--Addons!-->
            <!-- <ContentAddons ref="addons" :addons="revision.data.type.addons ? revision.data.type.addons : type.addons"
                            :content="content" @add-files-attachments="addFilesAttachments"
                            @remove-files-attachments="removeFilesAttachments" /> -->
          </div>
          <div v-if="!revisionChanged" class="button-bar">
            <fyi-button
              :label="'Selecionar'"
              :className="'default add'"
              :onclick="() => changeVersion()"
            />
            <fyi-button
              :label="'Cancelar'"
              :className="'default cancel'"
              :onclick="() => (revision = null)"
            />
          </div>
          <div v-if="revisionChanged" class="step-success">
            <div class="animation"></div>
            <label>Versão atualizada</label>
          </div>
        </div>
      </div>
    </teleport>
    <teleport to="body">
      <AddBlock :blocks="blocks" :content="content" v-if="addBlock" />
    </teleport>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Content",
  data() {
    return {
      content: null,
      revisions: [],
      type: null,
      parent_types: [],
      body: "",
      submitStatus: "READY",
      schedulerState: "publish",
      schedulerTime: null,
      schedulerDate: null,
      mediaOn: false,
      destination: null,
      toast_type: "",
      toast_message: "",
      toast_show: false,
      blocks: [],
      templates: [],
      content_history: false,
      revision: null,
      revisionChanged: false,
      cooldown: null,
      current_language: this.$store.getters.languages[0],
      language_index: 0,
      languageChange: 0,
      SEO: false,
      languageSelector: false,
      featureTemplate: true,
      removedVision: [],
      addedVision: [],
      addBlock: false,
    };
  },
  computed: {
    schedulerValue() {
      return (
        new Date(this.schedulerDate).toLocaleDateString("en-CA", {
          format: "short",
          year: "2-digit",
          month: "2-digit",
          day: "2-digit",
        }) +
        " " +
        this.schedulerTime.hours +
        ":" +
        this.schedulerTime.minutes +
        ":00"
      );
    },
  },
  async beforeMount() {
    // check if SEO feature enabled
    if (await this.featureEnabled("seo")) {
      this.SEO = true;
    }

    // if(!await this.featureEnabled('templates')){
    //     this.featureTemplate = false
    // }else{
    this.blocks = await this.getBlocks("type=content");
    //this.templates = await this.getTemplates();
    // }
    if (!(await this.featureEnabled("pages_create"))) {
      this.featureTemplate = false;
    }

    if (await this.featureEnabled("languages")) {
      this.languageSelector = true;
    }

    try {
      if (this.$store.getters.languages[0] == "[") {
        this.current_language = JSON.parse(this.$store.getters.languages)[0];
      }
      if (this.$route.name.includes("edit")) {
        this.content = await this.getContent({
          params: "template_info=1",
          id: this.$route.params.content_id,
        });
        this.current_language = this.$store.getters.languages.filter(
          (l) => this.content.languages[0].language.id === l.id
        )[0];

        this.$parent.$parent.content_name =
          this.content.languages[this.language_index].name;
        if (this.content.type.parent && this.content.type.parent != 0) {
          let parent = this.content.type.parent;
          let parent_types = [];
          while (parent != null && parent != 0) {
            let tmp = null;
            try {
              tmp = await this.getType(parent);
            } catch {
              //error but keep going
            }
            if (tmp != null) {
              parent_types.push(tmp);
              parent = tmp.parent;
            } else {
              parent = null;
            }
          }
          this.parent_types = parent_types.reverse();
        }
        if (await this.featureEnabled("revisions")) {
          let revisions = await this.getRevisions({
            id: this.$route.params.content_id,
          });
          this.revisions = revisions.reverse().slice(0, 20);
        }
      } else {
        let type = await this.getType(this.$route.query.id);
        this.type = type;
        await this.buildContentTemplate(type);
        this.$parent.$parent.content_name = "Novo Conteúdo";
        if (type.parent && type.parent != 0) {
          let parent = type.parent;
          let parent_types = [];
          while (parent != null && parent != 0) {
            let tmp = null;
            try {
              tmp = await this.getType(parent);
            } catch {
              //error but keep going
            }
            if (tmp != null) {
              parent_types.push(tmp);
              parent = tmp.parent;
            } else {
              parent = null;
            }
          }
          this.parent_types = parent_types.reverse();
        }
      }
      this.schedulerState =
        this.content.schedule_unpublished_at != null ? "unpublish" : "publish";
      this.$parent.$parent.transition = false;
    } catch (err) {
      // this.$router.push({name:"erro"});
    }
  },
  methods: {
    ...mapActions([
      "getRevisions",
      "getBlocks",
      "getTemplates",
      "getContent",
      "getType",
      "deleteBatchContents",
      "updateContent",
      "createContent",
      "togglePublished",
      "featureEnabled",
    ]),
    async buildContentTemplate(type) {
      let content = {
        languages: [
          {
            alias: "",
            image: "",
            image_name: "",
            alternative_image: "",
            name: "",
            body: "",
            description: "",
            language: { id: this.current_language.id },
          },
        ],
        updated_at: new Date().toLocaleDateString("en-US", {
          format: "short",
          year: "2-digit",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }),
        user: {
          name: this.$store.getters.auth.user.name,
        },
        type: type,
        extra_blocks: [],
        template: {},
      };

      type.addons.forEach((t) => {
        if (t == "attachment") {
          content.attachments = [];
        }

        if (t == "related") {
          content.related = [];
        }

        if (t == "categorie") {
          content.categories = [];
        }

        if (t == "field") {
          content.fields = [];
        }

        if (t == "event") {
          content.events = [];
        }

        if (t == "chart") {
          content.charts = [];
        }
        if (t == "livestream") {
          content.livestreams = [];
        }
        if (t == "catalogo") {
          content.catalogos = [];
        }
        if (t == "colecoe") {
          this.content.colecoes = [];
        }

        if (t == "play") {
          this.content.plays = [];
        }

        if (t == "modulo") {
          this.content.modulos = [];
        }
      });

      content.seo = [];

      this.content = content;
    },
    addImage(type) {
      this.destination = type;
      this.mediaOn = true;
    },
    removeImage(type) {
      if (type == "main")
        this.content.languages[this.language_index].image = null;
      else this.content.languages[this.language_index].alternative_image = null;
    },
    openBar(element) {
      document.querySelectorAll(".section.active").forEach((el) => {
        if (!el.classList.contains(element)) el.classList.remove("active");
      });
      this.$refs[element].classList.toggle("active");
    },
    addFilesAttachments(data) {
      let { files, category } = data;

      let order =
        this.content.attachments.filter(
          (a) => a.language_id == this.current_language.id
        ).length + 1;
      let tmpFiles = [];
      //create template_item
      files.forEach((f) => {
        let tmp = {};
        tmp.file = f.path;
        tmp.name = f.name;
        tmp.orderattachment = order;
        tmp.category_id = category;
        tmp.id = Math.floor(Math.random() * Number.MAX_VALUE);
        if (f.description) {
          tmp.description = f.description;
        }
        if (f.mime) {
          tmp.mimetype = f.mime;
          tmp.fileInfo = {
            size: f.size,
            dimensions: f.dimensions,
            user: f.user,
          };
        }
        tmp.language_id = this.current_language.id;
        tmpFiles.push(tmp);
        order++;
      });
      this.content.attachments = this.content.attachments.concat(tmpFiles);
    },
    removeFilesAttachments(id) {
      let attachments = this.content.attachments;
      let currentOrder = attachments.find((a) => a.id === id).orderattachment;
      console.log(currentOrder, id);
      //reorder every item after one position below
      for (let i = 0; i < attachments.length; i++) {
        if (
          attachments[i].language_id === this.current_language.id &&
          attachments[i].orderattachment > currentOrder
        )
          attachments[i].orderattachment -= 1;
        console.log(attachments[i].orderattachment, currentOrder);
      }

      //remove the desired item
      attachments.splice(
        attachments.findIndex((a) => a.id === id),
        1
      );
      this.content.attachments = attachments;
      console.log(this.content.attachments);
    },
    addFilesVision(data) {
      let files = data;

      let tmpFiles = [];
      //create template_item
      files.forEach((f) => {
        this.addedVision.push(f.path);
        let tmp = {};
        tmp.image = f.path;
        tmpFiles.push(tmp);
      });
      this.content.visions = this.content.visions.concat(tmpFiles);
    },
    removeFilesVision(id) {
      if (this.content.visions[id].id)
        this.removedVision.push(this.content.visions[id].id);

      let visions = this.content.visions;
      //remove the desired item
      visions.splice(id, 1);
      this.content.visions = visions;
    },
    async removeContent() {
      const ok = await this.$refs.modal.show({
        message: "Deseja remover o conteúdo selecionado?",
        okButton: "Remover conteúdo",
      });
      // If you throw an error, the method will terminate here unless you surround it wil try/catch
      if (ok) {
        await this.deleteBatchContents({ contents: this.content.id });
        this.$router.push({
          name: "pages_cms",
          params: { id: this.$route.params.id },
          query: { filter: this.content.type.id },
        });
      }
    },
    async togglePublish() {
      await this.togglePublished({
        published: this.content.published == 1 ? false : true,
        id: this.content.id,
      });
      this.content.published = this.content.published == 1 ? 0 : 1;
    },
    updateSEO(content) {
      if (content == null) return;

      let keywords = [],
        final = [],
        exclude_words = [
          "dos",
          "das",
          "de",
          "da",
          "do",
          "com",
          "nos",
          "nas",
          "no",
          "na",
          "as",
          "às",
          "os",
          "em",
          "para",
          "esta",
          "este",
          "através",
          "sobre",
          "quem",
          "que",
          "porque",
          "porquê",
          "sem",
          "sobre",
        ];

      content = content
        .replace(/<\/?[^>]+(>|$)/g, "")
        .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()\"\']/g, "")
        .replace(/(\r\n|\n|\r)/gm, " ")
        .replace(/\s{2,}/g, " ");

      content.split(" ").forEach(function (el, i, arr) {
        if (el.length > 1 && !exclude_words.includes(el) && isNaN(el))
          keywords[el] = keywords[el] ? ++keywords[el] : 1;
      });

      let tuples = [];

      for (let key in keywords) tuples.push([key, keywords[key]]);

      tuples.sort(function (a, b) {
        a = a[1];
        b = b[1];

        return a > b ? -1 : a < b ? 1 : 0;
      });

      let count = 0;
      for (let i = 0; i < (tuples.length < 6 ? tuples.length : 6); i++) {
        let key = tuples[i][0];
        let value = tuples[i][1];

        final.push({ text: key, id: count });
        count++;
      }

      this.$refs.seo.keywords = final;
      this.$refs.seo.keywordsUpdate++;

      this.$refs.seo.analyze();
    },
    setTemplate(id) {
      this.templates.forEach((t) => {
        if (t.id == id) {
          if (this.content.template == null)
            this.content.template = { name: t.name, template_id: t.id };
          else {
            this.content.template.template_id = t.id;
            this.content.template.name = t.name;
          }
        }
      });
    },
    removeTemplate() {
      this.content.template = null;
    },
    async toggleContentHistory() {
      if (await this.featureEnabled("revisions"))
        this.content_history = !this.content_history;
    },
    handleBody(text) {
      this.content.languages[0].body = text;
      clearTimeout(this.cooldown);
      this.cooldown = setTimeout(() => {
        this.updateSEO(text);
      }, 1000);
    },
    changeVersion() {
      const _this = this;
      this.content.languages[this.language_index].name =
        this.revision.data.languages &&
        this.revision.data.languages[this.language_index]
          ? this.revision.data.languages[this.language_index].name
          : "";
      this.content.languages[this.language_index].sub_name =
        this.revision.data.languages &&
        this.revision.data.languages[this.language_index]
          ? this.revision.data.languages[this.language_index].sub_name
          : "";

      this.$refs.body.$refs.editor.setContent(
        this.revision.data.languages &&
          this.revision.data.languages[this.language_index]
          ? this.revision.data.languages[0].body
          : ""
      );

      this.$refs.description.$refs.editor.setContent(
        this.revision.data.languages &&
          this.revision.data.languages[this.language_index]
          ? this.revision.data.languages[this.language_index].body
          : ""
      );
      this.content.languages[this.language_index].image =
        this.revision.data.languages &&
        this.revision.data.languages[this.language_index]
          ? this.revision.data.languages[this.language_index].image
          : "";

      _this.revisionChanged = true;
      setTimeout(function () {
        document.querySelector(".step-success .animation").innerHTML = "";
        bodymovin.loadAnimation({
          container: document.querySelector(".step-success .animation"),
          animationData: {
            v: "5.6.1",
            fr: 60,
            ip: 0,
            op: 93,
            w: 90,
            h: 90,
            nm: "Cashback Activation Animation",
            ddd: 0,
            assets: [],
            layers: [
              {
                ddd: 0,
                ind: 1,
                ty: 4,
                nm: "check",
                sr: 1,
                ks: {
                  o: { a: 0, k: 100, ix: 11 },
                  r: { a: 0, k: 0, ix: 10 },
                  p: { a: 0, k: [46, 46, 0], ix: 2 },
                  a: { a: 0, k: [-64.139, -543.26, 0], ix: 1 },
                  s: { a: 0, k: [39.706, 39.706, 100], ix: 6 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [0, 0],
                              [0.841, 0.133],
                              [-0.919, -0.115],
                            ],
                            o: [
                              [0, 0],
                              [0.059, 0.133],
                              [-1.115, -0.102],
                            ],
                            v: [
                              [-24.839, -568.19],
                              [-76.231, -518.331],
                              [-103.417, -545.583],
                            ],
                            c: false,
                          },
                          ix: 2,
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false,
                      },
                      {
                        ty: "st",
                        c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                        o: {
                          a: 1,
                          k: [
                            {
                              i: { x: [0.833], y: [1] },
                              o: { x: [0.167], y: [0] },
                              t: 62,
                              s: [0],
                              e: [100],
                            },
                            { t: 63 },
                          ],
                          ix: 4,
                        },
                        w: { a: 0, k: 18, ix: 5 },
                        lc: 2,
                        lj: 1,
                        ml: 4,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [0, 0], ix: 2 },
                        a: { a: 0, k: [0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100], ix: 3 },
                        r: { a: 0, k: 0, ix: 6 },
                        o: { a: 0, k: 100, ix: 7 },
                        sk: { a: 0, k: 0, ix: 4 },
                        sa: { a: 0, k: 0, ix: 5 },
                        nm: "Transform",
                      },
                    ],
                    nm: "Shape 1",
                    np: 3,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                  },
                  {
                    ty: "tm",
                    s: {
                      a: 1,
                      k: [
                        {
                          i: { x: [0.673], y: [1] },
                          o: { x: [0.34], y: [0] },
                          t: 62,
                          s: [0],
                          e: [100],
                        },
                        {
                          i: { x: [0.477], y: [0.892] },
                          o: { x: [0.061], y: [0] },
                          t: 63,
                          s: [100],
                          e: [0],
                        },
                        { t: 88 },
                      ],
                      ix: 1,
                    },
                    e: { a: 0, k: 100, ix: 2 },
                    o: { a: 0, k: 0, ix: 3 },
                    m: 1,
                    ix: 2,
                    nm: "Trim Paths 1",
                    mn: "ADBE Vector Filter - Trim",
                    hd: false,
                  },
                  {
                    ty: "gr",
                    it: [
                      {
                        ty: "st",
                        c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                        o: { a: 0, k: 0, ix: 4 },
                        w: { a: 0, k: 13, ix: 5 },
                        lc: 2,
                        lj: 1,
                        ml: 4,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [0, 0], ix: 2 },
                        a: { a: 0, k: [0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100], ix: 3 },
                        r: { a: 0, k: 0, ix: 6 },
                        o: { a: 0, k: 100, ix: 7 },
                        sk: { a: 0, k: 0, ix: 4 },
                        sa: { a: 0, k: 0, ix: 5 },
                        nm: "Transform",
                      },
                    ],
                    nm: "Group 1",
                    np: 1,
                    cix: 2,
                    bm: 0,
                    ix: 3,
                    mn: "ADBE Vector Group",
                    hd: false,
                  },
                ],
                ip: 0,
                op: 935,
                st: 0,
                bm: 0,
              },
              {
                ddd: 0,
                ind: 2,
                ty: 4,
                nm: "bg",
                sr: 1,
                ks: {
                  o: { a: 0, k: 100, ix: 11 },
                  r: { a: 0, k: 0, ix: 10 },
                  p: { a: 0, k: [45, 45, 0], ix: 2 },
                  a: { a: 0, k: [16.233, 24.733, 0], ix: 1 },
                  s: {
                    a: 1,
                    k: [
                      {
                        i: {
                          x: [0.385, 0.385, 0.663],
                          y: [0.996, 0.996, -36.691],
                        },
                        o: { x: [0.369, 0.369, 0.296], y: [0, 0, 0] },
                        t: 47,
                        s: [0, 0, 100],
                        e: [156.367, 156.367, 100],
                      },
                      {
                        i: { x: [0.558, 0.558, 0.812], y: [1.011, 1.011, 1] },
                        o: {
                          x: [0.239, 0.239, 0.427],
                          y: [-0.017, -0.017, 33.575],
                        },
                        t: 74,
                        s: [156.367, 156.367, 100],
                        e: [128.636, 128.636, 100],
                      },
                      { t: 93 },
                    ],
                    ix: 6,
                  },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [15.317, 0],
                              [0, -15.317],
                              [-15.317, 0],
                              [0, 15.317],
                            ],
                            o: [
                              [-15.317, 0],
                              [0, 15.317],
                              [15.317, 0],
                              [0, -15.317],
                            ],
                            v: [
                              [0, -27.733],
                              [-27.733, 0],
                              [0, 27.733],
                              [27.733, 0],
                            ],
                            c: true,
                          },
                          ix: 2,
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false,
                      },
                      {
                        ty: "fl",
                        c: {
                          a: 0,
                          k: [
                            0.22745098039215686, 0.7176470588235294,
                            0.8313725490196079, 1,
                          ],
                          ix: 4,
                        },
                        o: { a: 0, k: 100, ix: 5 },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [16.233, 24.733], ix: 2 },
                        a: { a: 0, k: [0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100], ix: 3 },
                        r: { a: 0, k: 0, ix: 6 },
                        o: { a: 0, k: 100, ix: 7 },
                        sk: { a: 0, k: 0, ix: 4 },
                        sa: { a: 0, k: 0, ix: 5 },
                        nm: "Transform",
                      },
                    ],
                    nm: "Ellipse 1",
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                  },
                ],
                ip: 0,
                op: 2400,
                st: 0,
                bm: 0,
              },
              {
                ddd: 0,
                ind: 3,
                ty: 4,
                nm: "progress",
                sr: 1,
                ks: {
                  o: { a: 0, k: 100, ix: 11 },
                  r: { a: 0, k: 180, ix: 10 },
                  p: { a: 0, k: [45, 45, 0], ix: 2 },
                  a: { a: 0, k: [111.5, 111.5, 0], ix: 1 },
                  s: { a: 0, k: [47, 47, 100], ix: 6 },
                },
                ao: 0,
                shapes: [
                  {
                    ty: "gr",
                    it: [
                      {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                          a: 0,
                          k: {
                            i: [
                              [-46.392, 0],
                              [0, 46.392],
                              [46.392, 0],
                              [0, -46.392],
                            ],
                            o: [
                              [46.392, 0],
                              [0, -46.392],
                              [-46.392, 0],
                              [0, 46.392],
                            ],
                            v: [
                              [0, 84],
                              [84, 0],
                              [0, -84],
                              [-84, 0],
                            ],
                            c: true,
                          },
                          ix: 2,
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false,
                      },
                      {
                        ty: "st",
                        c: {
                          a: 0,
                          k: [
                            0.22745098039215686, 0.7176470588235294,
                            0.8313725490196079, 1,
                          ],
                          ix: 3,
                        },
                        o: { a: 0, k: 100, ix: 4 },
                        w: { a: 0, k: 17, ix: 5 },
                        lc: 2,
                        lj: 1,
                        ml: 10,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false,
                      },
                      {
                        ty: "tr",
                        p: { a: 0, k: [111.5, 111.5], ix: 2 },
                        a: { a: 0, k: [0, 0], ix: 1 },
                        s: { a: 0, k: [100, 100], ix: 3 },
                        r: { a: 0, k: 0, ix: 6 },
                        o: { a: 0, k: 100, ix: 7 },
                        sk: { a: 0, k: 0, ix: 4 },
                        sa: { a: 0, k: 0, ix: 5 },
                        nm: "Transform",
                      },
                    ],
                    nm: "Group 1",
                    np: 2,
                    cix: 2,
                    bm: 0,
                    ix: 1,
                    mn: "ADBE Vector Group",
                    hd: false,
                  },
                  {
                    ty: "tm",
                    s: {
                      a: 1,
                      k: [
                        {
                          i: { x: [0.667], y: [1] },
                          o: { x: [0.783], y: [0] },
                          t: 0,
                          s: [100],
                          e: [0],
                        },
                        { t: 53 },
                      ],
                      ix: 1,
                    },
                    e: { a: 0, k: 100, ix: 2 },
                    o: { a: 0, k: 0, ix: 3 },
                    m: 1,
                    ix: 2,
                    nm: "Trim Paths 1",
                    mn: "ADBE Vector Filter - Trim",
                    hd: false,
                  },
                ],
                ip: -34,
                op: 967,
                st: 180,
                bm: 0,
              },
            ],
            markers: [],
          },
          renderer: "svg",
          loop: false,
          autoplay: true,
        });
        setTimeout(function () {
          _this.revisionChanged = false;
          _this.revision = null;
        }, 2000);
      }, 100);
    },
    setLanguage(lang) {
      let no_lang = true;
      lang = parseInt(lang);
      this.$store.getters.languages.forEach((l) => {
        if (l.id == lang) {
          this.current_language = l;

          this.content.languages.forEach((lg, k) => {
            if (lg.language.id == lang) {
              this.language_index = k;
              no_lang = false;
            }
          });
        }
      });

      if (no_lang) {
        this.content.languages.push({
          alias: "",
          image: "",
          image_name: "",
          alternative_image: "",
          name: "",
          body: "",
          description: "",
          language: { id: parseInt(lang) },
        });

        this.content.seo.push(this.content.seo[0]);

        this.type?.addons.forEach((t) => {
          if (t == "attachment") {
            this.content.attachments = [];
          }

          if (t == "related") {
            this.content.related = [];
          }

          if (t == "categorie") {
            this.content.categories = [];
          }

          if (t == "field") {
            this.content.fields = [];
          }

          if (t == "event") {
            this.content.events = [];
          }

          if (t == "chart") {
            this.content.charts = [];
          }

          if (t == "livestream") {
            this.content.livestreams = [];
          }

          if (t == "catalogo") {
            this.content.catalogos = [];
          }

          if (t == "colecoe") {
            this.content.colecoes = [];
          }

          if (t == "play") {
            this.content.plays = [];
          }

          if (t == "modulo") {
            this.content.modulos = [];
          }
        });

        this.language_index = this.content.languages.length - 1;
      }

      this.languageChange++;
      this.$forceUpdate();
    },
    replicate() {
      this.content.replicate = !this.content.replicate;
    },
    async saveContent() {
      try {
        //only base for now
        this.submitStatus = "PENDING";
        let languages = this.content.languages.map((l) => {
          let {
            alias,
            alternative_image,
            body,
            description,
            image,
            image_name,
            name,
            sub_name,
          } = l;
          let language_id = l.language ? l.language.id : 1;
          let created_at = this.content.created_at;

          return {
            alias,
            alternative_image,
            body,
            description,
            image,
            image_name,
            name,
            sub_name,
            language_id,
            created_at,
          };
        });

        let addons = {};

        if (this.content.attachments) {
          addons.attachment = this.content.attachments;
          if (
            this.$store.getters.headerDomain !== null &&
            this.$store.getters.headerDomain.includes("fiteidigital")
          ) {
            for (let i = 0; i < addons.attachment.length; i++) {
              if (
                addons.attachment[i].category_id === "" ||
                addons.attachment[i].category_id === null ||
                addons.attachment[i].category_id === undefined ||
                addons.attachment[i].category_id === 0
              ) {
                this.toast_type = "error";
                this.toast_message =
                  "Em algum dos anexos não foi definida categoria! Verifique a situação antes de prosseguir.";
                this.toast_show = true;
                this.submitStatus = "ERROR";
                return;
              }
            }
          }
        }

        if (this.$refs.addons.fields) {
          addons.field = [];
          this.$refs.addons.fields.forEach((f) => {
            f.values.forEach((v) => {
              if (v.value != null && v.value != "")
                addons.field.push({
                  id: f.field_id,
                  value: v.value,
                  language_id: v.language_id,
                });
            });
          });
        }

        if (this.$refs.addons.categories) {
          addons.category = [];
          this.$refs.addons.categories.forEach((c) => {
            if (c.value != null && c.value != false)
              addons.category.push(c.category_id);
          });
        }

        if (this.$refs.addons.events) {
          addons.event = this.$refs.addons.events;
        }

        if (this.$refs.addons.maps) {
          addons.map = this.$refs.addons.maps;
        }

        if (this.$refs.addons.livestream)
          addons.livestream = this.$refs.addons.livestream;

        if (this.$refs.addons.plays) {
          addons.play = this.$refs.addons.plays;
          addons.play.forEach((l) => {
            if (l.categories instanceof Array)
              l.categories = l.categories.map((c) => {
                return c.text;
              });
          });
        }

        if (this.$refs.addons.catalogos) {
          addons.catalogo = this.$refs.addons.catalogos;
          for (let i = 0; i < addons.catalogo.length; i++) {
            if (
              addons.catalogo[i].video !== "" &&
              addons.catalogo[i].video !== null &&
              addons.catalogo[i].video !== undefined
            ) {
              if (
                addons.catalogo[i].availability === null ||
                addons.catalogo[i].availability === undefined ||
                addons.catalogo[i].availability === ""
              ) {
                this.toast_type = "error";
                this.toast_message =
                  "Em algum dos idiomas não foi definida disponibilidade do conteúdo! Verifique a situação antes de prosseguir.";
                this.toast_show = true;
                this.submitStatus = "ERROR";
                return;
              }
              if (
                addons.catalogo[i].availability === "payperview" &&
                (addons.catalogo[i].price === null ||
                  addons.catalogo[i].price === "" ||
                  addons.catalogo[i].price === undefined ||
                  addons.catalogo[i].availability_time === null ||
                  addons.catalogo[i].availability_time === "" ||
                  addons.catalogo[i].availability_time === undefined)
              ) {
                this.toast_type = "error";
                this.toast_message =
                  "Em algum dos idiomas não foi definido o preço ou a duração da disponibilidade do conteúdo! Verifique a situação antes de prosseguir.";
                this.toast_show = true;
                this.submitStatus = "ERROR";
                return;
              }
            }
          }
          addons.catalogo.forEach((l) => {
            if (l.categories instanceof Array)
              l.categories = l.categories.map((c) => {
                return c.text;
              });
          });
        }

        if (this.$refs.addons.modulos) {
          addons.modulo = this.$refs.addons.modulos;
        }

        if (this.$refs.addons.colecoes) {
          addons.colecoe = this.$refs.addons.colecoes;
          addons.colecoe.forEach((l) => {
            if (l.categories instanceof Array)
              l.categories = l.categories.map((c) => {
                return c.text;
              });
          });
        }

        if (this.$refs.addons.nutrition) {
          addons.nutrition = [this.$refs.addons.nutrition];
        }

        if (this.$refs.addons.ic) {
          addons.imagecompare = this.$refs.addons.imageCompare();
        }

        if (this.content.relateds) {
          addons.related = this.content.relateds.map((r) => {
            return r.content_related_id;
          });
        }

        if (this.content.visions) {
          addons.vision = {
            news: this.addedVision,
            remove: this.removedVision,
          };
        }

        //SEO plugin
        if ((await this.featureEnabled("seo")) && this.$refs.seo) {
          addons.seo = this.$refs.seo.addon;

          addons.seo.forEach((seo, k) => {
            if (this.content.languages[k]) {
              seo.breadcrumb_title = this.$refs.seo.breadcrumb;
              seo.canonic_url = this.$refs.seo.canonic;
              let keywords = this.$refs.seo.keywords.map((k) => {
                return k.text;
              });
              seo.keywords = keywords;
              seo.language_id = this.content.languages[k]?.language.id;
            } else {
              addons.seo.splice(k, 1);
            }
          });
        }

        //Graph Addon

        if (this.content.charts) {
          addons.chart = this.$refs.addons.charts();
        }

        if (languages[this.language_index].name.trim() == "") {
          this.submitStatus = "ERROR";
          this.$refs.name.$el.classList.add("error");
          return;
        }

        let save = {
          type_id: this.content.type.id,
          languages: languages.filter((l) => l.name.trim() !== ""),
          addons: addons,
          template: this.content.template,
          extra_blocks: this.content.extra_blocks,
        };

        save["schedule_published_at"] = "remove";
        save["schedule_unpublished_at"] = "remove";

        if (this.schedulerDate != null && this.schedulerTime != null) {
          save["schedule_" + this.schedulerState + "ed_at"] =
            this.schedulerValue;
        }

        if (save["schedule_published_at"] != "remove") save.published = 0;
        else save.published = this.content.published;

        //replicate
        if (this.content.replicate) save.replicate = true;

        //set created_at
        save.created_at = this.content.created_at;

        if (this.$route.name.includes("edit")) {
          await this.updateContent({ params: save, id: this.content.id });
        } else {
          await this.createContent(save);
        }

        this.$router.push({
          name: "pages_cms",
          params: { id: this.$route.params.id },
          query: { filter: this.content.type.id },
        });
      } catch (err) {
        console.log(err);
        this.submitStatus = "ERROR";
        this.toast_type = "error";
        this.toast_message =
          "Ocorreu um erro, ao guardar o conteúdo. Tente novamente!";
        this.toast_show = true;
      }
    },
  },
  mounted() {
    if (this.$route.name.includes("edit"))
      this.$parent.$parent.view = this.$t("edit");
    else this.$parent.$parent.view = this.$t("Criar");
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/pages/content.scss";
</style>
